import { THIS_YEAR } from "../../utils/dates";

export const FIELDS = {
  TYPE: "type",
  COMPONENT: "component",
  CONNECTION: "connection",
  ORIGIN: "origin",
  METER: "meter",
  MEDIUM: "medium",
  METER_OR_MARKET_LOCATION: "meteringOrMarketLocation",
  FORMULA: "formulaStr",
  ESTIMATION_PROCEDURE: "estimationProcedure",
  REFERENCES: "references",
  CONSTANT_LOAD_KW: "constantLoadKw",
  CONSUMER_TYPE: "consumerType",
  NO_OF_CONSUMERS: "numberOfConsumers",
  SECURITY_BUFFER: "securityBuffer",
  RATIO_OF_ENERGY_DATA: "ratioOfEnergyData",
  ESTIMATION_ENERGY_DATA: "estimationEnergyData",
  ESTIMATION_ENERGY_DATA_EXAMPLE_MEASURING:
    "estimationEnergyDataExampleMeasuring",
  STATEMENT: "statement",
  ANNUAL_CONSUMPTION: "annualConsumption",
  CUSTOM_LABEL: "customLabel",
  FREQUENCY: "frequency",
  TAGS: "tags"
};

export const TYPES = {
  GENERATION: "generation",
  CONSUMPTION: "consumption",
  FEEDIN: "feedin",
  FEEDOUT: "feedout",
  MISC: "misc"
};

export const ORIGINS = {
  METER: "meter",
  COMPUTATION: "computation",
  ESTIMATION: "estimation"
};

export const ESTIMATION_PROCEDURES = {
  CONSTANT_LOAD: "constant_load",
  TYPICAL_STANDARD_VALUES: "typical_standard_values",
  TYPICAL_STANDARD_VALUES_15_MIN: "typical_standard_values_15_min",
  EXAMPLE_MEASURING: "example_measuring",
  NON_CALIBRATED_MEASURING: "non_calibrated_measuring",
  PARTIAL_RATIO: "parital_ratio",
  MISC: "misc"
};

export const TYPE_LABEL_MAP = {
  [TYPES.GENERATION]: "Erzeugung",
  [TYPES.CONSUMPTION]: "Verbrauch",
  [TYPES.FEEDIN]: "Einspeisung",
  [TYPES.FEEDOUT]: "Entnahme",
  [TYPES.MISC]: "Sonstiges"
};

export const ORIGIN_LABEL_MAP = {
  [ORIGINS.METER]: "Zähler",
  [ORIGINS.COMPUTATION]: "Berechnung",
  [ORIGINS.ESTIMATION]: "Schätzung"
};

export const EARLIEST_YEAR = 2020;
export const INITIAL_YEAR = Math.max(THIS_YEAR - 1, EARLIEST_YEAR);
